import { z } from "zod";

import {
	BasicCustomMailForReservationInputSchema,
	BasicCustomMailForShoppingInputSchema,
	BasicCustomMailItemSendOptionalInputSchema,
	BasicCustomMailItemSendRequiredInputSchema,
	BasicCustomMailSettingI18nInputSchema,
} from "@/lib/zod/__generated__/validation-schema";

const BasicCustomMailSettingI18nFormData = BasicCustomMailForReservationInputSchema.extend({
	//##################################################
	// 送信必須の項目のバリデーション
	//##################################################
	atCreated: BasicCustomMailItemSendRequiredInputSchema.extend({
		text: z.string().max(3_000),
	}),
	atUpdated: BasicCustomMailItemSendRequiredInputSchema.extend({
		text: z.string().max(3_000),
	}),
	atCanceled: BasicCustomMailItemSendRequiredInputSchema.extend({
		text: z.string().max(3_000),
	}),
	atRequest: BasicCustomMailItemSendRequiredInputSchema.extend({
		text: z.string().max(3_000),
	}),
	atConfirmed: BasicCustomMailItemSendRequiredInputSchema.extend({
		text: z.string().max(3_000),
	}),
	atDeclined: BasicCustomMailItemSendRequiredInputSchema.extend({
		text: z.string().max(3_000),
	}),

	//##################################################
	// 送信必須ではない項目のバリデーション
	//##################################################
	atCheckInBefore_07days: BasicCustomMailItemSendOptionalInputSchema.extend({
		text: z.string().max(3_000),
		shouldSendEmail: z.boolean(),
	}),
	atCheckInBefore_01days: BasicCustomMailItemSendOptionalInputSchema.extend({
		text: z.string().max(3_000),
		shouldSendEmail: z.boolean(),
	}),
	atCheckInBefore_00days: BasicCustomMailItemSendOptionalInputSchema.extend({
		text: z.string().max(3_000),
		shouldSendEmail: z.boolean(),
	}),
	atCheckOutAfter_01days: BasicCustomMailItemSendOptionalInputSchema.extend({
		text: z.string().max(3_000),
		shouldSendEmail: z.boolean(),
	}),
});

const BasicCustomMailForShoppingI18nFormData = BasicCustomMailForShoppingInputSchema.extend({
	//##################################################
	// 送信必須の項目のバリデーション
	//##################################################
	atCreated: BasicCustomMailItemSendRequiredInputSchema.extend({
		text: z.string().max(3_000),
	}),
});

export const basicCustomMailSettingI18nSchema = BasicCustomMailSettingI18nInputSchema.extend({
	forReservation: BasicCustomMailSettingI18nFormData,
	forShopping: BasicCustomMailForShoppingI18nFormData,
});

export type BasicCustomMailSettingFormData = z.infer<typeof basicCustomMailSettingI18nSchema>;
